module.exports = __webpack_public_path__ + "927ec303e2b4d2de58171e34952aac39.svg";